import { PointerEvent } from 'react';
import { getPlatform } from '../../utils';

export type CarouselSlideProps = {
  /**
   * The id of the control in the Dom.
   */
  id?: string;
  /**
   * The className of the control in the Dom.
   */

  className?: string;

  /**
   * Label text.
   */
  label?: string;
  /**
   * Order The Slide according to order number.
   */
  order?: number;
  children?: React.ReactNode;
};

interface InternalProps extends CarouselSlideProps {
  onSwipeLeft?: (ev: PointerEvent, props: { type: string }) => void;
}

export const withLogic =
  (
    Component: React.ComponentType<CarouselSlideProps>
  ): React.FC<CarouselSlideProps> =>
  (props: CarouselSlideProps) => {
    const internalProps = props as InternalProps;

    return (
      <Component
        {...{
          ...props,
          active: true,
          platform: getPlatform(),
          onPointerDown: (ev: PointerEvent<HTMLDivElement>) => {
            internalProps?.onSwipeLeft?.(ev, { type: 'touchdown' });
          },
          onPointerMove: (ev: PointerEvent<HTMLDivElement>) => {
            internalProps?.onSwipeLeft?.(ev, { type: 'touchmove' });
          },
          onPointerUp: (ev: PointerEvent<HTMLDivElement>) => {
            internalProps?.onSwipeLeft?.(ev, { type: 'touchup' });
          },
          onDragStart: (ev: PointerEvent<HTMLDivElement>) => {
            ev.preventDefault();
          },
          onDragEnd: (ev: PointerEvent<HTMLDivElement>) => {
            ev.preventDefault();
          }
        }}
      />
    );
  };
